module.exports = __webpack_public_path__ + "static/media/loader.white.min.4b461e9f.svg";